import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { RepositoryService } from 'src/smoothr-web-app-core/services/repository/repository.service';
import Venue from 'src/smoothr-web-app-core/models/Venue';
import { PreorderType } from 'src/smoothr-web-app-core/enums/PreorderType';
import { OrderType } from 'src/smoothr-web-app-core/enums/OrderType';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MapsUtils } from 'src/maps/utils/maps-leaflet';
import { getLatLng } from 'src/smoothr-web-app-core/utils/utils';
import { NavigationService } from 'src/app/services/navigation.service';
import { AngularFireAnalytics } from '@angular/fire/compat/analytics';

import * as leaflet from 'leaflet';
import '@maplibre/maplibre-gl-leaflet';

@Component({
	selector: 'app-venue',
	templateUrl: './venue.page.html',
	styleUrls: ['venue.page.scss'],
})
export class VenuePage implements OnInit {
	static url = 'store';
	private static venues: Venue[] = [];
	private static preorderType: PreorderType = null;

	@ViewChild('mapContainer', { static: false })
	gmap: ElementRef;
	map: leaflet.Map;

	loading = false;
	venues: Venue[];
	preorderType: PreorderType;
	showMap = false;
	clusterer: leaflet.MarkerClusterGroup = null;
	mapOptions: leaflet.MapOptions = {
		zoom: 18,
		maxZoom: 18,
		layers: [
			leaflet.maplibreGL({
				style: 'https://tiles.openfreemap.org/styles/positron',
			}),
		],
	};
	selectedVenue: Venue = null;

	constructor(
		private router: Router,
		private repository: RepositoryService,
		private snackbarCtrl: MatSnackBar,
		private analytics: AngularFireAnalytics,
		private navigatorService: NavigationService
	) {}

	static navigate(router: Router, venues: Venue[], preorderType: PreorderType) {
		VenuePage.venues = venues;
		VenuePage.preorderType = preorderType;
		router.navigateByUrl(VenuePage.url);
	}

	ionViewDidEnter() {
		// Initialize map only when view is fully entered
		this.map = new leaflet.Map(this.gmap.nativeElement, this.mapOptions);
		this.map.attributionControl.setPrefix('');

		if (this.venues.length !== 0) {
			const latLng = getLatLng(this.venues[0]);
			this.map.setView(new leaflet.LatLng(latLng.latitude - 0.00025, latLng.longitude));
			this.setupMap(this.venues[0], this.venues);
		} else {
			console.log('Venues with no coordinates');
		}
	}

	ngOnInit() {
		// Venues are already loaded from navigation
		this.venues = VenuePage.venues;
		this.preorderType = VenuePage.preorderType;

		// If venues aren't available, navigate back to home
		if (this.venues === undefined || this.venues === null || this.venues.length < 1 || !this.preorderType) {
			this.navigatorService.home();
			return;
		}
	}

	setupMap(selectedVenue: Venue, venues: Venue[]) {
		this.selectedVenue = selectedVenue;
		this.clusterer = MapsUtils.addVenuesToMap(this.clusterer, selectedVenue, venues, this.map, venue => this.setupMap(venue, venues));
	}

	async selectVenue(venue: Venue, preorderType: PreorderType, attempt: number = 0, prevError: any = null) {
		try {
			// Create order with venue ID (instant local operation)
			this.repository.createOrder(venue, null, OrderType.PREORDER, preorderType);

			// Navigate immediately - menu page skeleton will handle all loading
			await this.navigatorService.menu();

			// Analytics after navigation (non-blocking)
			this.analytics.logEvent('venue_selected', {
				name: venue.name,
				readableId: venue.readableId,
			});
		} catch (e) {
			console.error('Error selecting venue:', e);
		}
	}
}
